import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CallDirection, CallHistory, CallMissedReason } from '@app/call-history/models/call-history.models';
import { ContactByIdPipe } from '@app/shared/pipes/contact-by-id.pipe';
import { IncomingCallerDescriptionPipe } from '@app/shared/pipes/incoming-caller-description.pipe';
import { PhoneNumberPipe } from '@app/shared/pipes/phone-number.pipe';
import { SipUriNumberPipe } from '@app/shared/pipes/sip-uri-number.pipe';
import { TimestampPipe } from '@app/shared/pipes/timestamp.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule,
    PhoneNumberPipe,
    SipUriNumberPipe,
    TimestampPipe,
    ContactByIdPipe,
    TranslateModule,
    IncomingCallerDescriptionPipe,
  ],
  selector: 'app-call-history-item',
  templateUrl: './call-history-item.component.html',
  styleUrls: ['./call-history-item.component.scss'],
})
export class CallHistoryItemComponent {
  @Input() item: CallHistory;
  @Input() showPhoneNumbers: boolean;
  protected readonly CallDirection = CallDirection;
  protected readonly CallMissedReason = CallMissedReason;
}
